var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMarkerSel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 60,
    viewBox: "0 0 45 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7747_128623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 59V43",
    stroke: "#61686B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3.5,
    width: 39.0012,
    height: 39,
    rx: 19.5,
    fill: "#A31610"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3.5,
    width: 39.0012,
    height: 39,
    rx: 19.5,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3361 13.2526C20.715 12.9158 21.286 12.9158 21.6649 13.2526L30.6653 21.2526C31.0781 21.6195 31.1153 22.2516 30.7484 22.6644C30.3815 23.0771 29.7493 23.1143 29.3365 22.7474L29.0009 22.4491V30C29.0009 31.1046 28.1054 32 27.0008 32H15.0002C13.8956 32 13.0001 31.1046 13.0001 30V22.4491L12.6645 22.7474C12.2517 23.1143 11.6195 23.0771 11.2526 22.6644C10.8857 22.2516 10.9229 21.6195 11.3357 21.2526L20.3361 13.2526ZM15.0002 20.6713V30H18.0004V25C18.0004 24.4477 18.4481 24 19.0004 24H23.0006C23.5529 24 24.0006 24.4477 24.0006 25V30H27.0008V20.6713L21.0005 15.338L15.0002 20.6713ZM22.0005 30V26H20.0005V30H22.0005Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7747_128623",
    x: 0,
    y: -1,
    width: 47,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7747_128623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7747_128623",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMarkerSel);
export default __webpack_public_path__ + "static/media/homeMarkerSel.0bb1c5df23119f4e81e934c912d1e0f7.svg";
export { ForwardRef as ReactComponent };